// client/src/pages/ShopPOS/components/TransferFormModal.tsx
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface TransferData {
  fullName: string;
  ci: string;
  phone: string;
  transferCode: string;
  bank: string;
  firstFourDigits: string;
  lastFourDigits: string;
  destinationCard: string;
}

interface TransferFormModalProps {
  show: boolean;
  transferData: TransferData;
  onUpdateField: (field: keyof TransferData, value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
  bankCards?: any[]; // ← NUEVO: Tarjetas bancarias del shop (opcional)
}

export function TransferFormModal({
  show,
  transferData,
  onUpdateField,
  onConfirm,
  onCancel,
  bankCards = [], // ← NUEVO: Valor por defecto empty array
}: TransferFormModalProps) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
      <div className="bg-background rounded-lg p-6 w-full max-w-md max-h-[90vh] overflow-auto">
        <h3 className="text-lg font-bold mb-4">Datos de Transferencia</h3>
        <div className="grid gap-4">
          <Input
            placeholder="Nombre y Apellidos"
            value={transferData.fullName}
            onChange={(e) => onUpdateField("fullName", e.target.value)}
          />
          <Input
            placeholder="Número de Carnet de Identidad"
            value={transferData.ci}
            onChange={(e) => {
              const numericValue = e.target.value.replace(/[^0-9]/g, "");
              onUpdateField("ci", numericValue);
            }}
            inputMode="numeric"
            pattern="[0-9]*"
          />
          {transferData.ci && transferData.ci.length < 11 && (
            <p className="text-xs text-amber-600 mt-1">
              El CI debe tener 11 dígitos
            </p>
          )}
          <Input
            placeholder="Número de teléfono (solo números)"
            value={transferData.phone}
            onChange={(e) => {
              let value = e.target.value;
              if (value.startsWith("+")) {
                const numbers = value.substring(1).replace(/[^0-9]/g, "");
                value = "+" + numbers;
              } else {
                value = value.replace(/[^0-9]/g, "");
              }
              onUpdateField("phone", value);
            }}
            inputMode="tel"
            pattern="[0-9+]*"
          />
          {transferData.phone && (
            <p className="text-xs text-gray-500 mt-1">
              Formato: 54882577 o +5354882577
            </p>
          )}
          <Input
            placeholder="Código de transferencia"
            value={transferData.transferCode}
            onChange={(e) => onUpdateField("transferCode", e.target.value)}
          />
          <select
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            value={transferData.bank}
            onChange={(e) => onUpdateField("bank", e.target.value)}
          >
            <option value="">Selecciona tu banco</option>
            <option value="Bandec">Bandec</option>
            <option value="BPA">BPA</option>
            <option value="Banco Metropolitano">Banco Metropolitano</option>
          </select>
          {/* NUEVO: Selector de tarjeta de destino DINÁMICO */}
          <div className="mt-2">
            <label className="text-sm font-medium text-foreground mb-1 block">
              Tarjeta de Destino (opcional)
            </label>
            <select
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              value={transferData.destinationCard || ""}
              onChange={(e) => onUpdateField("destinationCard", e.target.value)}
            >
              <option value="">Selecciona una tarjeta (opcional)</option>
              {bankCards &&
                bankCards.map((card) => (
                  <option key={card.id} value={card.cardNumber}>
                    {card.nickname || "Sin nombre"} - {card.cardNumber}
                  </option>
                ))}
            </select>
            <p className="text-xs text-muted-foreground mt-1">
              {bankCards && bankCards.length > 0
                ? "Selecciona dónde recibirá el dinero el dueño del negocio"
                : "No hay tarjetas registradas. Configúralas en Ajustes."}
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm text-muted-foreground mb-1 block">
                Primeros 4 dígitos (opcional)
              </label>
              <Input
                placeholder="1234"
                value={transferData.firstFourDigits}
                onChange={(e) => {
                  const numericValue = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 4);
                  onUpdateField("firstFourDigits", numericValue);
                }}
                inputMode="numeric"
                maxLength={4}
              />
            </div>
            <div>
              <label className="text-sm text-muted-foreground mb-1 block">
                Últimos 4 dígitos (opcional)
              </label>
              <Input
                placeholder="5678"
                value={transferData.lastFourDigits}
                onChange={(e) => {
                  const numericValue = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 4);
                  onUpdateField("lastFourDigits", numericValue);
                }}
                inputMode="numeric"
                maxLength={4}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 mt-6">
          <Button className="w-full" onClick={onConfirm}>
            Confirmar Pago
          </Button>
          <Button variant="outline" className="w-full" onClick={onCancel}>
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
}
